

























import { Vue, Component, Prop } from 'vue-property-decorator';
import { Action, Getter } from 'vuex-class';
import IdeaSharingIcon from '../components/icons/IdeaSharingIcon.vue';
import EditIcon from '../components/icons/EditIcon.vue';
import Button from '../components/common/inputs/Button.vue';
import MarkdownEditor from '../components/common/inputs/MarkdownEditor.vue';
import { Cms } from '@/store/modules/commonInterfaces';
import { AuthModule } from '@/store/modules/auth';
import { CommonModule, CommonState } from '@/store/modules/common';

@Component({
  components: {
    IdeaSharingIcon,
    EditIcon,
    MarkdownEditor,
    Button
  }
})
export default class Home extends Vue {
  get state() {
    return CommonModule;
  }

  get isEditor() {
    return AuthModule.isFrontpageEditor;
  }

  editing = false;

  mounted() {
    CommonModule.loadCmsContent('frontPage');
  }

  update(partial: Partial<CommonState>) {
    CommonModule.update(partial);
  }

  save() {
    CommonModule.saveCmsContent({
      label: 'frontPage',
      content: !!CommonModule.frontPage ? CommonModule.frontPage : ''
    });
    this.editing = false;
  }
}
